import { SVGProps } from "react";
import { motion } from "framer-motion";

const VerticalGradientSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 3 140" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x={0.5} width={2} height={140} fill="url(#paint0_linear_1445_7874)" />
    <defs>
      <motion.linearGradient
        id="paint0_linear_1445_7874"
        x1={1.5}
        y1={0}
        x2={1.5}
        y2={140}
        gradientUnits="userSpaceOnUse"
        style={{ originX: "50%", originY: "50%" }} // Center the origin point
        animate={{ scale: [0, 1] }} // Final scale
        transition={{
          times: [0, 1],
          duration: 0.5,
          repeat: 0,
          type: "keyframes",
          ease: "easeIn",
        }}
      >
        <stop stopColor="#70767F" stopOpacity={0} />
        <stop offset={0.5} stopColor="#70767F" />
        <stop offset={1} stopColor="#70767F" stopOpacity={0} />
      </motion.linearGradient>
    </defs>
  </svg>
);

export default VerticalGradientSVG;
